import { fetchWithAuth } from "../../../../../../api-client/api_client";
import { APIEndpointMethod } from "../../../../../../models/Entities";
import { showErrorToast } from "../../../../../shared/Toasts";

interface AcknowledgeCommonModelDiffRunProps {
  onSuccess?: () => void;
}

const useAcknowledgeCommonModelDiffRun = ({ onSuccess }: AcknowledgeCommonModelDiffRunProps) => {
  const headers = {
    "Content-Type": "application/json",
  };

  const acknowledgeDiffRun = (diffRunId: string) => {
    if (!diffRunId) {
      return;
    }

    fetchWithAuth({
      path: `/blueprints/cmd-execution/${diffRunId}/acknowledge`,
      method: APIEndpointMethod.POST,
      headers,
      body: {},
      onResponse: () => {
        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (error) => {
        error
          ?.json()
          .then((value: string | Record<string, any>) => {
            let errorMessage = "";
            if (typeof value == "string") {
              errorMessage = value;
            } else {
              errorMessage = value?.non_field_errors ?? JSON.stringify(value);
            }
            showErrorToast(
              `Failed to acknowledge Common Model diff run. Error message: \n ${errorMessage}`
            );
          })
          .catch(() => {
            showErrorToast("Failed to acknowledge Common Model diff run");
          });
      },
    });
  };

  return { acknowledgeDiffRun };
};

export default useAcknowledgeCommonModelDiffRun;
